module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ef-Gc.dda9fbf7.png";